import React, {
    useState
} from 'react';

import { 
    useIonViewWillEnter,
    useIonRouter,
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonBackButton,
    NavContext,
    IonLabel,
    IonItem,
    IonInput,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonText,
    IonImg,
    IonIcon,
    IonFooter,
    IonList,
    IonNote,
    IonLoading
} from '@ionic/react';

import { refresh } from "ionicons/icons";
import { RouteComponentProps } from "react-router-dom";
import { isPlatform, getPlatforms  } from '@ionic/react';

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { hideTab } from "../components/Tabs";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  


const MantainApp : React.FC = () => {

    const [mantainMode, setMantainMode] = useState(true);
    const [msg, setMsg] = useState("");
    const [showLoading, setShowLoading] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        hideTab();
        getData();
    });

    const getData = async () => {
        
        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const uid = v.account.id;
        
        let platform = "unknown";
        if (isPlatform("desktop"))
            platform = "desktop";
        if (isPlatform("android"))
            platform = "android";
        if (isPlatform("ios"))
            platform = "ios";

        let platform_ids = getPlatforms();

        const state = {
            id: uid,
            platform: platform,
            platform_ids: platform_ids
        }

		var server = new NServer();
        await server.getList("app_info", state);

        setShowLoading(false);

        if (server.success && server.message != "")
            showAlert(server.message);
        else
        {
            let manMode = server.data.mantain == "yes";
            setMantainMode(manMode);
            setMsg(server.data.msg);

            if (!manMode)
                router.push("/loader", "back", "pop");
        }
	};

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    
                </IonToolbar>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonImg className="icon-pic ion-margin-bottom" src="/assets/img/big_logo.png" />
                            <div className="ion-text-center ion-margin-bottom">{ GetStr(LANGUAGE.TXT_MAN_TITLE_1) }</div>
                            <div className="ion-text-center ion-margin-bottom"><h1>{ GetStr(LANGUAGE.TXT_MAN_TITLE_2) }</h1></div>
                            <IonCard>
                                <IonCardContent>
                                    <IonList className="update-box">
                                        <IonItem>
                                            <IonText className="text-wrap">{ msg }</IonText>
                                        </IonItem>
                                    </IonList>
                                </IonCardContent>
                            </IonCard>
                            </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <IonFooter>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonButton className="main-but ion-margin" color="primary" expand="block" onClick={getData}>
                                <IonIcon icon={refresh} />&nbsp;
                                { GetStr(LANGUAGE.TXT_MAN_REFRESH) }
                            </IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};

export default MantainApp;